const loadingConstants = {};

loadingConstants.TOGGLE_LOADING = 'TOGGLE_LOADING'

export default loadingConstants;



/** WEBPACK FOOTER **
 ** ./src/constants/loading.js
 **/